import { render, staticRenderFns } from "./bottomBarSet.vue?vue&type=template&id=63b2b606&scoped=true"
import script from "./bottomBarSet.vue?vue&type=script&lang=js"
export * from "./bottomBarSet.vue?vue&type=script&lang=js"
import style0 from "./bottomBarSet.vue?vue&type=style&index=0&id=63b2b606&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b2b606",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63b2b606')) {
      api.createRecord('63b2b606', component.options)
    } else {
      api.reload('63b2b606', component.options)
    }
    module.hot.accept("./bottomBarSet.vue?vue&type=template&id=63b2b606&scoped=true", function () {
      api.rerender('63b2b606', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/settings/components/bottomBarSet.vue"
export default component.exports